export default "images/idea.png";